import { useCallback, useEffect, useState } from 'react';

function normalizePath(pathname) {
  const raw = String(pathname || '/').split('?')[0] || '/';
  if (raw === '/') return '/';
  return `/${raw.replace(/^\/+|\/+$/g, '')}`;
}

function readLocation() {
  if (typeof window === 'undefined') return { pathname: '/', search: '' };
  return {
    pathname: normalizePath(window.location.pathname),
    search: window.location.search || '',
  };
}

export default function useTavolataRouter() {
  const [location, setLocation] = useState(readLocation);

  useEffect(() => {
    const onPopState = () => setLocation(readLocation());
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const navigate = useCallback((pathname, options = {}) => {
    const path = normalizePath(pathname);
    const params = new URLSearchParams();
    Object.entries(options.query || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null && String(value) !== '') params.set(key, String(value));
    });
    const search = params.toString() ? `?${params.toString()}` : '';
    const url = `${path}${search}`;
    if (options.replace) window.history.replaceState({}, '', url);
    else window.history.pushState({}, '', url);
    setLocation({ pathname: path, search });
  }, []);

  const query = new URLSearchParams(location.search);
  return { ...location, query, navigate };
}
